var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isHeader === 0)?_c('Header'):_vm._e(),(_vm.isHeader === 1)?_c('HeaderT'):_vm._e(),(_vm.isHeader === 2)?_c('HeaderAgen'):_vm._e(),_c('router-view'),(_vm.isFooter)?_c('Footer'):_vm._e(),(_vm.isOpenRegister)?_c('Register'):_vm._e(),(_vm.isOpenLogin)?_c('Login'):_vm._e(),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }